import { render, staticRenderFns } from "./PurchaseRecipesTab.vue?vue&type=template&id=c91a36f0&scoped=true&"
import script from "./PurchaseRecipesTab.vue?vue&type=script&lang=js&"
export * from "./PurchaseRecipesTab.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRecipesTab.vue?vue&type=style&index=0&id=c91a36f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91a36f0",
  null
  
)

export default component.exports